import { useState } from "react";
import { register } from "../firebase/auth";
import { db } from "../firebase/config";
import { setDoc, doc } from "firebase/firestore";
import { sendEmailVerification } from "firebase/auth";
import { useNavigate, Link } from "react-router-dom";
import { Form, Button, Container, Alert, Row, Col } from "react-bootstrap";

export default function RegisterAccount() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [message, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const roles = ["Student", "Faculty"];

  const handleRegister = async () => {
    if (!email.endsWith("@ggc.edu")) {
      setMessage("Registration is only allowed with a GGC email (@ggc.edu).");
      return;
    }

    try {
      const userCredential = await register(email, password);
      const user = userCredential.user;

      await setDoc(doc(db, "users", user.uid), {
        firstName,
        lastName,
        email: user.email,
        role: selectedRole === "Student"
          ? ["Student"]
          : ["Faculty", "Instructor", "Proctor"],
        approved: selectedRole === "Student",
        disabled: false,
        department: selectedRole === "Faculty" ? [] : null,
      });

      await sendEmailVerification(user);

      setMessage("Registration successful! A confirmation email has been sent to your inbox. Please verify your email.");

      setTimeout(() => {
        navigate("/SimpleLogin");
      }, 3000);
    } catch (error) {
      console.error("Error during registration:", error);
      setMessage(error.message);
    }
  };

  return (
    <Container>
      <Row className="justify-content-md-center">
        <Col md={6}>
          <h2 className="my-4 text-center">Register</h2>
          {message && <Alert variant="info">{message}</Alert>}
          <Form onSubmit={(e) => e.preventDefault()}>
            <Form.Group controlId="firstName">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter first name"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group controlId="lastName">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter last name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group controlId="email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group controlId="password">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type={showPassword ? "text" : "password"}
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <Button
                variant="link"
                className="password-toggle-btn"
                onClick={() => setShowPassword(!showPassword)}
                style={{ padding: 0, fontSize: "12px", color: "#007bff", textDecoration: "none" }}
              >
                {showPassword ? "Hide" : "Show"} Password
              </Button>
            </Form.Group>

            <Form.Group controlId="role">
              <Form.Label>Role</Form.Label>
              <Form.Control
                required
                as="select"
                value={selectedRole}
                onChange={(e) => setSelectedRole(e.target.value)}
              >
                <option value="">Choose Role</option>
                {roles.map((role) => (
                  <option key={role} value={role}>
                    {role}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

            <div className="mt-3 d-flex gap-2">
              <Button variant="primary" type="submit" onClick={handleRegister}>
                Register
              </Button>
            </div>
          </Form>

          <div className="my-1 text-primary">
            Already have an account?{" "}
            <Link to="/SimpleLogin" className="text-decoration-none text-primary">
              Login here.
            </Link>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
